module.exports = __webpack_public_path__ + "static/img/about-contact.5b817c67.png";